<template>
    <jet-section>
        <template #title>
            Subscriptions
        </template>
        <template #description>
            Update your email subscriptions.


        </template>
        <template #content>
            <div v-for="availableSubscription in availableSubscriptions" class="mb-4">
                <SwitchGroup as="div" class="flex items-center justify-between">
                    <span class="grow flex flex-col">
                        <SwitchLabel as="span" class="text-sm font-medium text-gray-900 dark:text-white" passive>{{ availableSubscription.name }}</SwitchLabel>
                        <SwitchDescription as="span" class="text-sm text-gray-500 dark:text-gray-100">{{ availableSubscription.description }}</SwitchDescription>
                    </span>
                    <Switch v-model="models[availableSubscription.id]" :class="[isActive(availableSubscription) ? 'bg-racing-stars-yellow' : 'bg-gray-200', 'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow']" @click="updateSubscription(availableSubscription)">
                        <span aria-hidden="true" :class="[isActive(availableSubscription) ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200']" />
                    </Switch>
                </SwitchGroup>

            </div>
            If you have any questions about your marketing prefrences, please <a href="mailto:support@racingstars.co.uk">contact us</a>
        </template>
    </jet-section>
</template>
<script>
import { ref, reactive } from 'vue'
import JetSection from '@/Jetstream/Section.vue'
import { Switch, SwitchDescription, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import { Inertia } from '@inertiajs/inertia'

export default {
    components: {
        JetSection,
        Switch,
        SwitchDescription,
        SwitchGroup,
        SwitchLabel,
    },

    props: {
        availableSubscriptions: Object,
        subscriptions: Object,
    },

    setup(props) {
        const models = reactive([
            false,
            false,
            false,
            false,
        ])

        const isActive = subscription => {
            let active = props.subscriptions.some(e => e.id === subscription.id)

            if (active) {
                models[subscription] = true
            }

            return active
        }

        const updateSubscription = subscription => {
            let form = Inertia.form({
                id: subscription.id
            })

            form.post(route('subscriptions'), {
                onSuccess: () => {
                    //
                }
            })
        }

        return {
            isActive,
            updateSubscription,
            models,
        }
    }
}

</script>
